import { request } from "../../config/request.ts";

export interface SortOrderScope {
  [key: string]: string | number;
}

export interface SortOrderPayload {
  tableName: string;
  rowId: number | string;
  orderedIds: Array<number | string>;
  idField?: string;
  sortField?: string;
  offset?: number;
  scope?: SortOrderScope;
}

export interface SortOrderResponse {
  status: boolean;
  message?: string;
}

export async function updateTableSortOrder(
  payload: SortOrderPayload,
): Promise<SortOrderResponse> {
  const response = await request.patch<SortOrderResponse>("sort-order", {
    tableName: payload.tableName,
    rowId: payload.rowId,
    orderedIds: payload.orderedIds,
    idField: payload.idField ?? "id",
    sortField: payload.sortField ?? "sort_order",
    offset: payload.offset ?? 0,
    scope: payload.scope,
  });
  return response.data;
}